module.exports = __webpack_public_path__ + "static/img/xf1.72f4849d.png";